exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table.SubP-table[data-v-56ad36f5]{margin-top:20px;border-collapse:collapse;border:1px solid #ccc}table.SubP-table tr th[data-v-56ad36f5]{border:1px solid #ccc;height:48px}table.SubP-table tr td[data-v-56ad36f5]{padding-left:4px;border-right:1px solid #ccc}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-56ad36f5","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/lending/subProjectInfo/insertForm.vue
// module id = 1497
// module chunks = 3